export enum CompanyTeamNotesToastBlock {
  Root = 'CompanyTeamNotesToast',
}

export enum CompanyTeamNotesToastModificator {
  Owner = 'owner',
}
